import React from 'react';
import {Control, UseFormGetValues, UseFormRegister} from 'react-hook-form';

import IHttpMonitorOutput from 'features/http/model/HttpMonitor/IHttpMonitor';

import CheckingContent from '../../CheckingContent/CheckingContent';
import FieldCard from '../FieldCard/FieldCard';
import {getBodyMethodHint} from '../checkboxBlockHints';

import styles from '../CheckboxBlock.module.scss';

interface IContentFieldProps {
    item?: IHttpMonitorOutput,
    getValues: UseFormGetValues<any>,
    control: Control<any>,
    register: UseFormRegister<any>,
    selective: boolean,
    freeTariff: boolean,
    bodyMethodDisabled: boolean,
    onCheckboxClick: () => void,
    onRemove?: () => void,
}

const ContentField: React.FC<IContentFieldProps> = ({
    item,
    getValues,
    control,
    register,
    selective,
    freeTariff,
    bodyMethodDisabled,
    onCheckboxClick,
    onRemove,
}) => (
    <FieldCard selective={selective} freeTariff={freeTariff} onRemove={onRemove}>
        <CheckingContent
            item={item}
            getValues={getValues}
            control={control}
            register={register}
            enabled={true}
            onCheckboxClick={onCheckboxClick}
            disabled={bodyMethodDisabled}
            hideArrow={selective}
        />
        {bodyMethodDisabled && (
            <p className={styles.methodHint}>{getBodyMethodHint()}</p>
        )}
    </FieldCard>
);

export default ContentField;
